import React, { useState, useEffect } from 'react';
import Project from './Project';
import './WebDevelopment.css';
const WebDevelopment = () => {
    const [projects, setProjects] = useState([]);
    useEffect(() => {
        fetch('data.json')
            .then(res => res.json())
            .then(data => setProjects(data))
    }, []);
    console.log(projects)
    return (
        <div className=" web-project-container" style={{ backgroundColor: '#121212' }}>
            <div class="row row-cols-1 row-cols-md-3 g-4 container mx-auto">
                {
                    projects.map(project => <Project project={project} key={Math.floor(Math.random() * 1000000000000000)}></Project>)
                }
            </div>
        </div>
    );
};

export default WebDevelopment;